import { TestLocators } from 'constants/Locators';

import { MUI, ThemeMode } from 'ci-esi-web-shared';
import { useTranslation } from 'react-i18next';

import { formatTestLocator } from 'helpers/formatters';
import { translations } from 'locales/i18n';
import { colors } from 'styles/theme/colors';

export interface ContactProps {
  index: number;
}

export function Contact({ index }: ContactProps) {
  const theme = MUI.useTheme();
  const isDarkMode = theme.palette.mode === ThemeMode.DARK;
  const { t } = useTranslation();
  const { REGION, PHONES, OFFICE_HOURS } = translations.HELP.CONTACTS[index];
  const testId = formatTestLocator(`${TestLocators.Header_Help_MenuItem}_Contact`, t(REGION));

  const infoSx = {
    color: `${isDarkMode ? colors.baseGrey10 : colors.baseGrey80}!important`,
    fontWeight: theme.typography.fontWeightRegular,
  };

  return (
    <MUI.MenuItem
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        cursor: 'default',
        '&:hover': { background: 'none' },
      }}
    >
      <MUI.Typography variant="h4" sx={{ color: isDarkMode ? colors.baseGrey20 : colors.baseGrey80 }}>
        {t(REGION)}
      </MUI.Typography>
      <MUI.Typography
        component="a"
        href={`tel:${t(PHONES)}`}
        variant="body2"
        data-testid={testId}
        sx={{
          ...infoSx,
          textDecoration: 'none!important',
          '&:hover': { color: `${isDarkMode ? colors.baseGrey10 : colors.primary}!important` },
        }}
      >
        {t(PHONES)}
      </MUI.Typography>
      <MUI.Typography variant="body2" sx={infoSx}>
        {t(OFFICE_HOURS)}
      </MUI.Typography>
    </MUI.MenuItem>
  );
}
